import { render, staticRenderFns } from "./goodsOnput.vue?vue&type=template&id=ce50de2e&scoped=true&"
import script from "./goodsOnput.vue?vue&type=script&lang=js&"
export * from "./goodsOnput.vue?vue&type=script&lang=js&"
import style0 from "./goodsOnput.vue?vue&type=style&index=0&id=ce50de2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce50de2e",
  null
  
)

export default component.exports